import React, { useCallback, useEffect, useState } from 'react'
import {
  CASINO_FAVORITES_CHANGED_EVENT,
  getCasinoFavorites,
  type FavoriteCasinoGame,
} from '../../utils/casinoFavoritesStore'
import { useCasinoUi } from '../../context/CasinoUiContext'
import LotusCasinoGameCard from '../LotusCasinoGameCard/LotusCasinoGameCard'
import './LotusCasinoRecommendedSection.css'

const LotusCasinoFavoritesView: React.FC = () => {
  const { playGame } = useCasinoUi()
  const [favorites, setFavorites] = useState<FavoriteCasinoGame[]>(() => getCasinoFavorites())

  const refresh = useCallback(() => {
    setFavorites(getCasinoFavorites())
  }, [])

  useEffect(() => {
    window.addEventListener(CASINO_FAVORITES_CHANGED_EVENT, refresh)
    return () => window.removeEventListener(CASINO_FAVORITES_CHANGED_EVENT, refresh)
  }, [refresh])

  return (
    <div className="lotus-casino-favourites-wrapper">
      <div className="lotus-casino-lobby-group__title">Favorites</div>
      {favorites.length === 0 ? (
        <p className="lotus-casino-favourites-empty">
          No favorite casino games yet. Tap the star on any game to add it here.
        </p>
      ) : (
        <div className="lotus-casino-lobby-group__grid">
          {favorites.map((fav) => (
            <LotusCasinoGameCard
              key={fav.gameId}
              game={{
                identifier: fav.identifier || fav.gameId,
                game_name: fav.gameName,
                game_images: fav.imageUrl,
                provider: fav.provider,
              }}
              onPlay={playGame}
              compact
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default LotusCasinoFavoritesView
